import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { SETTINGS_TABS } from './settingsTabs';

const SettingsTabNav = ({ activeTab, onTabChange }) => (
  <Box
    component="nav"
    aria-label="Settings sections"
    sx={{
      width: { xs: '100%', md: 230 },
      flexShrink: 0,
      borderRight: { md: '1px solid' },
      borderRightColor: { md: 'divider' },
      borderBottom: { xs: '1px solid', md: 'none' },
      borderBottomColor: { xs: 'divider', md: 'transparent' },
      p: { xs: 1.5, md: '26px 18px' },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'row', md: 'column' },
        gap: { xs: 0.5, md: 0.25 },
        overflowX: { xs: 'auto', md: 'visible' },
      }}
    >
      {SETTINGS_TABS.map(({ id, label, Icon }) => {
        const isActive = activeTab === id;

        return (
          <ButtonBase
            key={id}
            onClick={() => onTabChange(id)}
            aria-current={isActive ? 'page' : undefined}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: 1.35,
              width: { xs: 'auto', md: '100%' },
              flexShrink: 0,
              textAlign: 'left',
              borderRadius: '9px',
              px: 1.5,
              py: 1.35,
              bgcolor: isActive
                ? (theme) => theme.portal?.accentSoft ?? 'action.selected'
                : 'transparent',
              color: isActive ? 'text.primary' : 'text.secondary',
              transition: 'background-color 150ms ease, color 150ms ease',
              '&:hover': {
                bgcolor: isActive
                  ? (theme) => theme.portal?.accentSoft ?? 'action.selected'
                  : 'action.hover',
                color: 'text.primary',
              },
            }}
          >
            <Icon sx={{ fontSize: 17, color: 'inherit' }} />
            <Typography
              component="span"
              sx={{
                fontSize: '0.84375rem',
                fontWeight: isActive ? 700 : 500,
                color: 'inherit',
                whiteSpace: 'nowrap',
                lineHeight: 1.3,
              }}
            >
              {label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  </Box>
);

export default SettingsTabNav;
